/**
 * Local (per browser) preferences for the File ▸ Home landing: pinned publications and the recently opened list.
 * Cloud projects carry their own `updated_at`; pins and "last opened here" live in localStorage.
 */
const PINS_KEY = 'wp.pinnedProjects';
const RECENTS_KEY = 'wp.recentProjects';
const MAX_RECENTS = 12;

const read = (key, fallback) => {
  try { const v = JSON.parse(window.localStorage.getItem(key)); return Array.isArray(v) ? v : fallback; } catch { return fallback; }
};
const write = (key, value) => { try { window.localStorage.setItem(key, JSON.stringify(value)); } catch { /* storage unavailable */ } };

export const getPinnedIds = () => read(PINS_KEY, []);
export const isPinned = (id) => getPinnedIds().includes(id);
export const togglePinned = (id) => {
  const pins = getPinnedIds();
  const next = pins.includes(id) ? pins.filter((p) => p !== id) : [...pins, id];
  write(PINS_KEY, next);
  return next;
};

/** [{ id, openedAt }] newest first. */
export const getRecents = () => read(RECENTS_KEY, []);
export const touchRecent = (id) => {
  if (!id) return getRecents();
  const next = [{ id, openedAt: new Date().toISOString() }, ...getRecents().filter((r) => r.id !== id)].slice(0, MAX_RECENTS);
  write(RECENTS_KEY, next);
  return next;
};
export const forgetRecent = (id) => { const next = getRecents().filter((r) => r.id !== id); write(RECENTS_KEY, next); return next; };

/** Human friendly relative time ("Just now", "5 min ago", "Yesterday", or a date). */
export const relativeTime = (iso) => {
  if (!iso) return '';
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '';
  const diff = Date.now() - t;
  const min = Math.round(diff / 60000);
  if (min < 1) return 'Just now';
  if (min < 60) return `${min} min ago`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h} hour${h === 1 ? '' : 's'} ago`;
  const d = Math.round(h / 24);
  if (d === 1) return 'Yesterday';
  if (d < 7) return `${d} days ago`;
  return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
};

export const greeting = (date = new Date()) => {
  const h = date.getHours();
  if (h < 5) return 'Working late';
  if (h < 12) return 'Good morning';
  if (h < 18) return 'Good afternoon';
  return 'Good evening';
};
